import * as TweenJS from "slotworks/utils/tween";
import * as particles from "pixi-particles";
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { CenterPivot } from "slotworks/graphics/pixi/group";
import { Easing } from "slotworks/utils/tween";
import currency from "slotworks/i18n/currency";
import { Sprite, Container } from "pixi.js";
import graphicsManager from "slotworks/graphics/graphics-manager";
import { sequence } from "slotworks/utils/race-utils";
import translations from "slotworks/i18n/translations";
import deviceInfo from "slotworks/utils/device-info";
import soundManager from "slotworks/sound/sound-manager";

export class ChancesMeter {

    public static CONTAINER_NAME = "chances_meter_container";
    public static MAX_CHANCES = 3;

    public container: Container;
    public count: number = 0;

    private chancesText: PIXI.Text;
    private containerY: number;

    constructor() {
        this.setUp();
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.add(this.setUp);
        }
    }

    public setValue(value: number, instant: boolean = false) {
        if(instant || this.count == value) {
            this.chancesText.text = translations.get("rsf.chn") + " " + value;
            this.count = value;
        } else {
            this.count = value;
            soundManager.customEvent("jp_chance_meter");
            new TweenJS.Tween(this.container)
            .to({y: this.container.y-40}, 140)
            .onComplete(() => {
                this.chancesText.text = translations.get("rsf.chn") + " " + value;
                new TweenJS.Tween(this.container)
                .to({y: this.containerY}, 150)
                .easing(Easing.Back.Out)
                .start();
            })
            .start();
        }
    }

    public decrement() {
        return this.setValue(this.count - 1);
    }

    public maxChances() {
        if(this.count < ChancesMeter.MAX_CHANCES) {
            const obj = { value: this.count }
            new TweenJS.Tween(obj)
            .to({value: ChancesMeter.MAX_CHANCES}, 200)
            .onUpdate(() => this.setValue(Math.floor(obj.value), true))
            .start();
        }
    }

    public destroy() {
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.remove(this.setUp);
        }
    }

    private setUp = () => {
        // plank, chances, vine
        this.chancesText = Layers.Custom.get("RespinBackground").getText("chances");
        this.chancesText.y -= 3;
        this.chancesText.angle = 13.5;
        const plank = Layers.Custom.get("RespinBackground").getSprite("plank");
        const vine = Layers.Custom.get("RespinBackground").getSprite("vine");

        this.container = CenterPivot([plank, vine, this.chancesText], ChancesMeter.CONTAINER_NAME);
        this.containerY = this.container.y;

        this.setValue(ChancesMeter.MAX_CHANCES, true);
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/respin/respin-chances-meter.ts